import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ActivityPurchaseFormType } from '../component/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<ActivityPurchaseFormType>();
  const [activityPurchases, otherCost, discount] = useWatch({
    control,
    name: ['activityPurchases', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = (activityPurchases || []).reduce((prev, ap) => {
      const subtotalGuest = ap.activityPurchaseGuests
        .map((apg) => apg.activityPurchaseGuestDetails)
        .flat()
        .reduce((prev, apd) => prev + (apd?.totalPrice || 0), 0);

      const subtotalAddOns = ap.activityPurchaseAddOns.reduce(
        (prev, fpao) => prev + (fpao.price || 0),
        0,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const totalAddOns = (activityPurchases || []).reduce((prev, ap) => {
      return (
        prev +
        ap.activityPurchaseAddOns.reduce(
          (prev, fpao) => prev + (fpao.price || 0),
          0,
        )
      );
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
      totalAddOns,
    };
  }, [activityPurchases, discount, otherCost, setValue]);

  return data;
}
